import { api } from '../../helpers/Api';
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    /*read(id?: number) {
      if (id)
        return api.get('tags/' + id).then(tag => new Tag(tag))
      return api.get('tags?order=name')
    }*/
    default_1.prototype.read = function () {
        return api.get("tags?eager=translations").then(function (tags) {
            return new Promise(function (resolve, reject) {
                var mappedTags = tags.map(function (t) {
                    var temp = {
                        id: t.id,
                        name: t.name,
                        value: t.translations ? t.translations.reduce(function (previous, current) {
                            if (!previous[current.languageCode.toLowerCase()]) {
                                previous[current.languageCode.toLowerCase()] = current.name;
                            }
                            return previous;
                        }, {}) : t.name
                    };
                    return temp;
                }).sort(function (a, b) { return a.name.localeCompare(b.name); });
                resolve(mappedTags);
            });
        });
    };
    default_1.prototype.addMultiple = function (value) {
        return api.post('tags/multiple', value);
    };
    default_1.prototype.create = function (data) {
        return api.post('tags', data);
    };
    default_1.prototype.update = function (id, data) {
        return api.put('tags/' + id, data);
    };
    default_1.prototype.delete = function (id) {
        throw new Error('Method not implemented.');
    };
    default_1.prototype.disable = function (id, disabled) {
        throw new Error('Method not implemented.');
    };
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Tags/TagsStore.ts
// module id = 753
// module chunks = 0